/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.Tile.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.Tile.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration", "option_tile_label.tpl", "option_tile_thumbnail.tpl"], function (require, exports, Backbone_1, OptionTiles_Configuration_1, tileLabelTemplate, tileThumbnailTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TileView = void 0;
    var TileView = /** @class */ (function (_super) {
        __extends(TileView, _super);
        function TileView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = _this.isEnabledThumbnailUsage() ? tileThumbnailTemplate : tileLabelTemplate;
            _this.isSelectedTile = options.currentGiftCertificate.internalId === _this.model.internalId;
            return _this;
        }
        TileView.prototype.getContext = function () {
            return {
                itemId: this.model.internalId,
                itemURL: this.model.url,
                isSelectedTile: this.isSelectedTile,
                tileLabel: this.model.label,
                thumbnail: this.model.thumbnail,
            };
        };
        TileView.prototype.isEnabledThumbnailUsage = function () {
            return OptionTiles_Configuration_1.OptionTilesConfiguration.useThumbnailInButtonLabel;
        };
        return TileView;
    }(Backbone_1.View));
    exports.TileView = TileView;
});
